// ReferralCards.jsx
// 👉 Version React avec CSS classique (aucune librairie externe)

import "./referral-cards.css";
import logoTiime from "./tiime.png"
import logoQonto from "./qonto.png"
// 👉 Remplace ces liens par TES liens de parrainage
const QONTO_REFERRAL_LINK = "https://qonto.com/fr/r/5yznkj";
const TIIME_REFERRAL_LINK = "https://lb.affilae.com/r/?p=651c0d1e40e2d575f87b3b27&af=585&lp=https%3A%2F%2Fwww.tiime.fr%2Fhome-page%3Futm_source%3Dother%26utm_medium%3Daffiliation%26utm_campaign%3DIntereseaux%26ae%3D585%26program_id%3D651c0d1e40e2d575f87b3b27%26program_name%3DTiime";

export function QontoReferralCard() {
  return (
    <div className="ref-card">
      <div className="ref-header">
        <div className="ref-header-top">

          <img
            src={logoQonto}
            alt="Qonto"
            className="ref-logo"
          />
          <span className="ref-badge">Compte pro</span>
        </div>
        <h3>Qonto – Le compte pro moderne</h3>
      </div>

      <p className="ref-description">
        Qonto simplifie la gestion bancaire des freelances, startups et PME avec
        une interface claire, rapide et pensée pour gagner du temps.
      </p>

      <ul className="ref-list">
        <li>IBAN français et cartes bancaires physiques & virtuelles</li>
        <li>Paiements, virements et exports comptables en quelques clics</li>
        <li>Support client rapide et efficace</li>
        <li>Parfait pour séparer pro et perso</li>
      </ul>

      <a
        href={QONTO_REFERRAL_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="ref-button primary"
      >
        Créer un compte Qonto
      </a>
    </div>
  );
}

export function TiimeReferralCard() {
  return (
    <div className="ref-card">
      <div className="ref-header">
        <div className="ref-header-top">

          <img
            src={logoTiime}
            alt="Tiime"
            className="ref-logo"
          />
          <span className="ref-badge secondary">Comptabilité</span>
        </div>
        <h3>Tiime – La compta sans stress</h3>
      </div>

      <p className="ref-description">
        Tiime automatise la facturation et la comptabilité pour te permettre de
        te concentrer sur ton activité, sans jargon comptable.
      </p>

      <ul className="ref-list">
        <li>Devis et factures conformes en quelques secondes</li>
        <li>Synchronisation bancaire automatique</li>
        <li>Partage facile avec ton expert-comptable</li>
        <li>Idéal pour indépendants et freelances</li>
      </ul>

      <a
        href={TIIME_REFERRAL_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="ref-button secondary"
      >
        Découvrir Tiime
      </a>
    </div>
  );
}
export function PartnersSection() {
  return (
    <section className="partners-section">
      <div className="partners-header">
        <h2>Découvrez nos partenaires</h2>
        <p>
          Nous recommandons ces outils de confiance pour simplifier la gestion
          financière et comptable de votre activité.
        </p>
      </div>


      <div className="ref-grid">
        <TiimeReferralCard />
      </div>
    </section>
  );
}